import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import CreditCardMonth from './credit-card-month-dropdown';
import CreditCardYear from './credit-card-year';
import useCreditCardField from '../use-credit-card-field';
import { CREDIT_CARD_FIELDS } from '../constants';

import messages from '../message';

import commonStyles from '../style.module.less';
import style from './style.module.css';

const CreditCardExpiration = () => {
  const { error: monthErrors } = useCreditCardField(CREDIT_CARD_FIELDS.CARD_EXPIRATION_MONTH);
  const { error: yearErrors } = useCreditCardField(CREDIT_CARD_FIELDS.CARD_EXPIRATION_YEAR);

  const hasExpirationError = (errors) => {
    if (!errors) {
      return false;
    }
    return errors.some((err) => {
      return err.messageDescriptor === messages.expiredCard;
    });
  };
  const hasExpiredDate = hasExpirationError(monthErrors?.errors) || hasExpirationError(yearErrors?.errors);
  const errorMessage = <FormattedMessage {...messages.expiredCard} />;
  const ignoreIndividualInputErrorMessage = hasExpiredDate;
  return (
    <div>
      <label className={commonStyles.label}>
        <FormattedMessage {...messages.cardExpirationLabel} />
      </label>
      <div className={style['input-container']}>
        <div className={style['month-container']}>
          <CreditCardMonth ignoreError={ignoreIndividualInputErrorMessage} />
        </div>
        <div className={style['year-container']}>
          <CreditCardYear ignoreError={ignoreIndividualInputErrorMessage} />
        </div>
      </div>
      {hasExpiredDate && errorMessage && (
        <div className={commonStyles['error-prompt']}>
          <FontAwesomeIcon className={commonStyles['error-icon']} icon={faExclamationCircle} />
          {errorMessage}
        </div>
      )}
    </div>
  );
};
export default CreditCardExpiration;
